module.exports = __webpack_public_path__ + "assets/clubdeferias-ico-pickdate.3b4807d1.svg";